import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithErrorHandling } from "../baseQuery";

export const contactApi = createApi({
  reducerPath: "contactApi",
  baseQuery: baseQueryWithErrorHandling,

  tagTypes: ["ContactData"],

  endpoints: (builder) => ({
    submitContact: builder.mutation({
      query: (data) => ({
        url: "/contact",
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),

    getContactData: builder.query({
      query: ({ search = "", page = 1, limit = 10 }) => ({
        url: `/contact?search=${search}&page=${page}&limit=${limit}`,
        method: "GET",
      }),
      providesTags: ["ContactData"],
    }),

    disableContact: builder.mutation({
      query: (id) => ({
        url: `/contact/${id}/disable`,
        method: "PATCH",
      }),
      invalidatesTags: ["ContactData"],
    }),
  }),
});

export const {
  useSubmitContactMutation,
  useGetContactDataQuery,
  useDisableContactMutation,
} = contactApi;
